import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject
} from '@angular/core';
import { selectorCoreRouterUrl } from '@bepatient/core';
import {
  selectorOnboardingSelectedTosDetails,
  TOSDetailsType
} from '@bepatient/onboarding-store';
import { Subscription } from 'rxjs';
import { CommonUtilsService } from '../../services/common-utils.service';

@Component({
  selector: 'bepatient-tos-details',
  templateUrl: './tos-details.component.html',
  styleUrls: ['./tos-details.component.scss'],
  standalone: false
})
export class TosDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  commonUtils = inject(CommonUtilsService);

  @Input() title: string;
  @Input() color: string;
  @Input() content: string;
  @Input() items: Array<TOSDetailsType>;

  private subscription: Subscription;

  isOnboarding: boolean;
  tosDetailsOnboarding$: any;

  ngOnInit(): void {
    this.subscription = this.commonUtils
      .storeSelect(selectorCoreRouterUrl)
      .subscribe(url => {
        if (url.includes('onboarding')) {
          this.isOnboarding = true;
          this.tosDetailsOnboarding$ = this.commonUtils.storeSelect(
            selectorOnboardingSelectedTosDetails
          );
        }
      });
  }

  ngAfterViewInit(): void {
    if (this.isOnboarding) {
      this.subscription = this.tosDetailsOnboarding$.subscribe(data =>
        !!data ? (this.items = data) : void 0
      );
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
